<template>
  <section class="sick-signs new-report__section">
    <h3 class="new-report__heading">
      PROXIMITY OF DEAD DEER TO WATER (POND, LAKE, STREAM, RIVER)
    </h3>
    <section class="new-report__multiselect-container">
      <label
        for="water-proximity"
        class="new-report__label new-report__label--inline"
      >
        Proximity Range
      </label>
      <multiselect
        id="water-proximity"
        name="water-proximity"
        placeholder="-- Please Select --"
        class="new-report__input new-report__input--select"
        required=""
        track-by="name"
        label="label"
        :options="promixities"
        :value="getWaterProximity"
        @input="updateWaterProximity"
      />
    </section>
  </section>
</template>

<script>
import { get } from "lodash";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      waterProximity: null,
      promixities: [
        {
          label: "Not near water",
          name: "water_deer0",
        },
        {
          label: "In water or touching",
          name: "water_deer1",
        },
        {
          label: "Less than 10 feet",
          name: "water_deer2",
        },
        {
          label: "10 to 20 feet",
          name: "water_deer3",
        },
        {
          label: "21 to 40 feet",
          name: "water_deer4",
        },
        {
          label: "More than 40 feet",
          name: "water_deer5",
        },
      ],
    };
  },

  computed: {
    getWaterProximity() {
      const wp = get(this, "$store.state.incidentReport.waterProximity");
      const val = Object.keys(wp).find((p) => wp[p] === true);
      const selectedObj = this.promixities.find((p) => p.name === val);
      return selectedObj;
    },
  },

  methods: {
    updateWaterProximity(value) {
      const val = this.promixities.find((p) => p.label === value.label);
      this.$store.commit("incidentReport/setWaterProximity", val.name);
    },
  },
};
</script>
